export default __webpack_public_path__ + "f086b6aa92b26dd6bffba368697e6134.png";